module.exports = __webpack_public_path__ + "img/action-start.11fbfdb5.svg";